import { DeleteOutlined, EyeOutlined, UnorderedListOutlined, FormOutlined } from "@ant-design/icons";
import { PageHeader, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

class Conteos extends Component {
    tableRef = null;
    state = {
        todosConteos: [],
        loading: false,
        valor: 1,
    };
    consultarConteos(params) {
        this.setState({ loading: true });
        axios
            .post(
                "conteos/selectTodasConteos",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todosConteos: [] });
                } else {
                    this.setState({
                        todosConteos: res.data.data.map(valueConteo => {
                            return {
                                ...valueConteo,
                                numero: (valueConteo.serie ? (valueConteo.serie + " - ") : "") + (valueConteo.numero || ""),
                                supervisorNombre: valueConteo.supervisor ? (
                                    valueConteo.supervisor.nombre + " " +
                                    valueConteo.supervisor.apellidoPaterno + " " +
                                    valueConteo.supervisor.apellidoMaterno
                                ) : "",
                                proyectoNombre: valueConteo.proyecto ? valueConteo.proyecto?.nombre : "",
                            }
                        }),
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    cancelarConteo(value) {
        this.setState({ loading: true });
        axios
            .post(
                "conteos/cancelarConteo",
                { conteoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Conteo cancelado correctamente");
                } else {
                    message.error("Sucedio un error y no se pudo cancelar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    agregarConteo() {
        this.props.history.push('/panel/agregarConteo');
    }

    verConteo(id) {
        this.props.history.push('/panel/detalleConteo/' + id);
    }

    verConteoLlenado(id) {
        this.props.history.push('/panel/verConteo/' + id);
    }

    verConfiguracion(id) {
        this.props.history.push('/panel/verConfigConteo/' + id);
    }

    render() {
        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                buscar: "numero",
                width: "6%",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                width: "13%",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion",
                buscar: "descripcion",
                width: "18%",
            },
            {
                title: "Estrategia Selec.",
                dataIndex: "estrategiaSeleccionInsumos",
                key: "estrategiaSeleccionInsumos",
                width: "11%",
                render: (value) => {
                    switch (value) {
                        case 1: return "Más rotación";
                        case 2: return "Menos rotación";
                        case 3: return "Aleatorio (existentes)";
                        case 4: return "Aleatorio (todos)";
                        case 5: return "Todos";
                        case 6: return "Todos con existencia";
                        default: return "—";
                    }
                }
            },
            {
                title: "Modo conteo",
                dataIndex: "modoConteo",
                key: "modoConteo",
                width: "9%",
                render: (value) => {
                    switch (value) {
                        case 1: return "Ciego";
                        case 2: return "Semi-ciego";
                        case 3: return "Abierto";
                        default: return "—";
                    }
                }
            },
            {
                title: "Proyecto",
                dataIndex: "proyectoNombre",
                key: "proyectoNombre",
                width: "11%",
            },
            {
                title: "Supervisor",
                dataIndex: "supervisorNombre",
                key: "supervisorNombre",
                width: "11%",
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "7%",
                render: (value) => {
                    if (value === 0) return <Tag color="red">Cancelado</Tag>;
                    if (value === 1) return <Tag color="blue">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">En proceso</Tag>;
                    if (value === 3) return <Tag color="green">Finalizado</Tag>;
                    return "—";
                },
            },
            {
                title: "Acción",
                key: "accion",
                width: "17%",
                render: (value, record) => (
                    <div className="acciones-container">
                        <Tooltip title="Resumen">
                            <ButtonItem
                                type="primary"
                                size="small"
                                verde
                                icon={<EyeOutlined />}
                                onClick={() => this.verConteo(record._id)}
                            />
                        </Tooltip>
                        <Tooltip title="Ver llenado">
                            <ButtonItem
                                type="default"
                                size="small"
                                icon={<UnorderedListOutlined />}
                                onClick={() => this.verConteoLlenado(record._id)}
                                style={{ marginLeft: 4 }}
                            />
                        </Tooltip>
                        <Tooltip title="Ver configuración">
                            <ButtonItem
                                type="default"
                                size="small"
                                morado
                                icon={<FormOutlined />}
                                onClick={() => this.verConfiguracion(record._id)}
                                style={{ marginLeft: 4 }}
                            />
                        </Tooltip>
                        {record.estado === 1 && (
                            <Tooltip title="Cancelar conteo">
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    rojo
                                    icon={<DeleteOutlined />}
                                    onClick={() => this.cancelarConteo(record._id)}
                                    style={{ marginLeft: 4 }}
                                />
                            </Tooltip>
                        )}
                    </div>
                ),
            },
        ];

        return (
            <>
                <PageHeader
                    title="Conteos"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: 'Vigente', value: 1 }, { label: "Finalizado", value: 2 }, { label: 'Cancelado', value: 3 }, { label: 'Todos', value: 4 }]}
                                        onChange={(value) => {
                                            if (this.tableRef) {
                                                this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                            }
                                            this.setState({ valor: value });
                                        }}
                                        value={this.state.valor}
                                    />
                                </>
                            }
                            <ButtonItem
                                type="primary"
                                key="agregarConteo"
                                onClick={this.agregarConteo.bind(this)}
                                 className="botonAgregar"
                                 olivo
                            >
                                Agregar Conteo
                            </ButtonItem>
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarConteos.bind(this)}
                    anadirValorFiltro={this.state.valor}
                    size="small"
                    onlyMineFilter
                    dataSource={this.state.todosConteos}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    filterStorageKey={"conteos" + this.props.empresaId}
                    onRow={(record) => ({
                        onDoubleClick: () => {
                            this.verConteo(record._id);
                        },
                    })}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        usuarioId: state.user.usuarioId,
    };
};

export default connect(mapStateToProps)(Conteos);
